import { Box, Container, Flex, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { Data } from "../../../../pages/Context/DataContext";
import { useContext } from "react";

const BottomList = () => {
  const { handleManufacturer } = useContext(Data);
  const ListArray = [
    <Link to="/">
      <Text key="home" fontWeight="bold" fontSize="14px" whiteSpace="nowrap" color="black">
        Home
      </Text>
    </Link>,
    <Link to="/products">All Products</Link>,
    <Link to="/products">Abbott</Link>,
    <Link to="/products">Albert David Ltd</Link>,
    <Link to="/products">Cipla Ltd</Link>,
    <Link to="/products">Lupin Ltd</Link>,
    <Link to="/products">Sanofi India  Ltd</Link>,
    <Link to="/products">USV Ltd</Link>,
    <Link to="/products">Zydus Cadila</Link>,
  ];

  return (
    <Box bg="rgb(255,255,255)" padding="5px">
      <Container size={"10xl"}>
        <Flex margin="auto" justifyContent="center" gap={"2%"}>
          {ListArray.map((ele, index) => {
            return (
              <Link key={index} to={`/products`} onClick={() => handleManufacturer(`${ele.props.children==="Home" || ele.props.children==="All Products" ? "" : ele.props.children }`)}>
                <Text
                  fontWeight="bold"
                  fontSize="14px"
                  whiteSpace="nowrap"
                  color="black"
                  borderBottom="2px solid transparent"
                  transition="all 0.2s ease-in-out"
                  _hover={{
                    borderBottom: "2px solid #5e17eb",
                    paddingBottom: "2px",
                  }}
                >
                  {ele}
                </Text>
              </Link>
            );
          })}
        </Flex>
      </Container>
    </Box>
  );
};

export default BottomList;